import { $ as $effect, A as tryRunPromise, B as succeedAsync, C as trySync, D as syncEffectImmediate, E as promiseImmediate, F as fromBoolean, G as mapErrorPassThrough, H as mapErrorDefault, I as fromCoerced, J as left, K as UnknownError, L as fromCondition, M as trySyncImmediate, N as failAsync, O as syncImmediate, P as failAsyncWith, Q as succeed, R as fromNullable, S as tryPromise, T as promiseEffectImmediate, U as mapErrorEffectDefault, V as succeedAsyncWith, W as mapErrorEffectPassThrough, X as right, Y as none, Z as some, _ as mapSpread, a as flatMapSpread, b as sync, c as mapAsyncSpread, d as mapLeft, et as $exec, f as mapLeftAsync, g as mapRightSpread, h as mapRightAsyncSpread, i as flatMap, j as tryRunSync, k as tryPromiseImmediate, l as mapError, m as mapRightAsync, n as pipe, nt as fromAsync, o as map, p as mapRight, q as fail, r as pipeMap, s as mapAsync, t as returnsEffect, tt as $next, u as mapErrorAsync, v as promise, w as fromExpression, x as syncEffect, y as promiseEffect, z as invert } from "../lib/tools-DixHU8ol.mjs";
import { t as limit2 } from "../lib/limit2-D0c9Lzoq.mjs";
/*                                         */
/**
 *
 *
 *
 *
 */
var AggregatedError = class AggregatedError extends AggregateError {
	name = "AggregatedError";
	/**
 *
 */
	errors;
	/**
 *
 *
 *
 *
 */
	constructor(errors, message) {
		super(errors, message);
		this.errors = [...errors];
	}
	static stringifyError(expand, e) {
		if (e instanceof AggregatedError) return e.toString(expand);
		if (e instanceof Error) return e.stack ?? e.message;
		return `${e}`;
	}
	/**
 *
 *
 *
 *
 */
	toString(expand = false) {
		if (!expand || this.errors.length === 0) return super.toString();
		return `${this.stack ?? super.toString()}\n\n  Aggregated Errors:\n\n${this.errors.map(AggregatedError.stringifyError.bind(this, expand)).join(`\n${"-".repeat(10)}\n`).split("\n").map((m) => `    ${m}`).join("\n")}`;
	}
};
/*        */
/*                                          */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function aggregateFailures(results, message) {
	const failed = results.filter((res) => res[$effect] === "left");
	return failed.length > 0 ? fail(new AggregatedError(failed.map(([error]) => error), message ?? "One or more effects failed to resolve")) : succeed(results.map(([, value]) => value));
}
/*        */
/*                            */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function allSync(effects, options = {}) {
	return aggregateFailures(effects, options.message);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function allAsync(effects, options = {}) {
	return fromAsync(Promise.all(effects).then((v) => aggregateFailures(v, options.message)));
}
/*        */
/*                              */
function catchError(handler) {
	const onFailure = (e) => handler(e.left);
	return (effect) => effect[$next](void 0, onFailure);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const catchFailure = catchError;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function catchErrorAsync(handler) {
	const onFailure = (e) => fromAsync(handler(e.left));
	return (effect) => effect[$next](void 0, onFailure);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const catchFailureAsync = catchError;
function catchType(type, handler) {
	const onFailure = (e) => e.left instanceof type ? handler(e.left) : e;
	return (effect) => effect[$next](void 0, onFailure);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function catchTypeAsync(type, handler) {
	const onFailure = (e) => e.left instanceof type ? fromAsync(handler(e.left)) : e;
	return (effect) => effect[$next](void 0, onFailure);
}
function catchName(name, handler) {
	const onFailure = (e) => {
		const err = e.left;
		return typeof err === "object" && !!err && "name" in err && err.name === name ? handler(err) : e;
	};
	return (effect) => effect[$next](void 0, onFailure);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function catchNameAsync(name, handler) {
	const onFailure = (e) => {
		const err = e.left;
		return typeof err === "object" && !!err && "name" in err && err.name === name ? fromAsync(handler(err)) : e;
	};
	return (effect) => effect[$next](void 0, onFailure);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function catchSome(handler) {
	const onFailure = (e) => {
		const res = handler(e.left);
		return res[$effect] === "right" ? res[1] : e;
	};
	return (effect) => effect[$next](void 0, onFailure);
}
/*        */
/*                               */
const pushWithOptions = (array, value, flatValue) => {
	array.push(...flatValue && Array.isArray(value) ? value : [value]);
};
/**
 *
 *
 *
 *
 *
 *
 *
 */
function concatenate(input, result, options) {
	const { flatInput = true, flatResult = true } = options;
	const resultArray = [];
	pushWithOptions(resultArray, input, flatInput);
	pushWithOptions(resultArray, result, flatResult);
	return succeed(resultArray);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapConcat = (mapper, options = {}) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => concatenate(e[1], mapper(e[1]), options));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapConcatSpread = (mapper, options = {}) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => concatenate(e[1], mapper(...e[1]), options));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapConcatAsync = (mapper, options = {}) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => fromAsync(mapper(e[1]).then((result) => concatenate(e[1], result, options))));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const mapConcatAsyncSpread = (mapper, options = {}) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => fromAsync(mapper(...e[1]).then((re) => concatenate(e[1], re, options))));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const flatMapConcat = (mapper, options = {}) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => mapper(e[1])[$next]((re) => concatenate(e[1], re[1], options)));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const flatMapConcatSpread = (mapper, options = {}) => ((onSuccess) => (effect) => effect[$next](onSuccess))((e) => mapper(...e[1])[$next]((re) => concatenate(e[1], re[1], options)));
/*        */
/*                               */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const isRight = (effect) => effect[$effect] === "right";
/**
 *
 *
 *
 *
 *
 */
const isSome = isRight;
/**
 *
 *
 *
 *
 *
 */
const isSuccess = isRight;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const isLeft = (effect) => effect[$effect] === "left";
/**
 *
 *
 *
 *
 *
 */
const isNone = isLeft;
/**
 *
 *
 *
 *
 *
 */
const isFailure = isLeft;
/*        */
/*                           */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function mapIf(handler) {
	return (effect) => effect[$next]((e) => e[1] ? handler.onTrue() : handler.onFalse());
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function ifImmediate(condition, { onTrue, onFalse }) {
	return mapIf({
		onTrue,
		onFalse
	})(succeed(condition));
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function mapIfEffect(condition, handler) {
	const onSucceed = (e) => condition ? handler.onTrue(e[1]) : handler.onFalse(e[1]);
	return (effect) => effect[$next](onSucceed);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function when(predicate) {
	const onSucceed = (e) => succeed(predicate(e[1]) ? some(e[1]) : none());
	return (effect) => effect[$next](onSucceed);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function whenEffect(predicate) {
	const onSucceed = (e) => {
		return pipe(predicate(e[1]), map((p) => p ? succeed(e[1]) : fail(void 0)));
	};
	return (effect) => effect[$next](onSucceed);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
function unless(predicate) {
	const onSucceed = (e) => succeed(predicate(e[1]) ? fail(void 0) : succeed(e[1]));
	return (effect) => effect[$next](onSucceed);
}
/*        */
/*                                */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function mapEach(mapper) {
	const onSuccess = (e) => succeed(e[1].map(mapper));
	return (effect) => effect[$next](onSuccess);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function mapEachAsync(mapper) {
	const onSuccess = (e) => succeedAsync(Promise.all(e[1].map(mapper)));
	return (effect) => effect[$next](onSuccess);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function mapEachLimit(mapper, options) {
	const onSuccess = (e) => succeedAsync(limit2(e[1], mapper, options));
	return (effect) => effect[$next](onSuccess);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function flatMapEach(mapper, options) {
	const onSuccess = (e) => {
		const r = e[1].map(mapper);
		if (r[0] && r[0][$exec] === "async") return fromAsync(Promise.all(r).then((re) => aggregateFailures(re, options?.message)));
		return aggregateFailures(r, options?.message);
	};
	return (effect) => effect[$next](onSuccess);
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function flatMapEachLimit(mapper, options) {
	const onSuccess = (e) => fromAsync(limit2(e[1], mapper, options).then((v) => aggregateFailures(v, options?.message)));
	return (effect) => effect[$next](onSuccess);
}
/*        */
/*                              */
/**
 *
 *
 *
 *
 *
 */
function match(param) {
	const onSucceedWrapper = (e) => succeed(param.onSucceed(e[1]));
	const onFailWrapper = (e) => succeed(param.onFail(e[0]));
	return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
/**
 *
 *
 *
 *
 *
 */
function matchAsync(param) {
	const onSucceedWrapper = (e) => succeedAsync(param.onSucceed(e[1]));
	const onFailWrapper = (e) => succeedAsync(param.onFail(e[0]));
	return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
/**
 *
 *
 *
 *
 *
 */
function matchEffect(param) {
	const onSucceedWrapper = (e) => param.onSucceed(e[1]);
	const onFailWrapper = (e) => param.onFail(e[0]);
	return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
/*        */
/*                              */
/**
 *
 *
 *
 */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
function policy(options) {
	if (Object.values(options).every((v) => v === void 0)) throw new Error("You must provide at least one option to the policy function");
	const { times = 0, delay = 0 } = options;
	let currentRetry = 0;
	const until = options.until ?? (() => times && currentRetry >= times);
	return (failure) => {
		currentRetry += 1;
		return until(failure[0]) ? failure : succeedAsync(new Promise((r) => {
			if (delay) {
				setTimeout(() => r(true), delay);
				return;
			}
			r(true);
		}));
	};
}
function retry(task, retryPolicy) {
	const retrier = async (args) => {
		const errors = [];
		while (true) {
			const res = await task(...args);
			if (isSuccess(res)) return res;
			errors.push(res[0]);
			const policyRes = await retryPolicy(res);
			if (isFailure(policyRes)) return fail(new AggregatedError([...errors, policyRes[0]], `Retry operation failed with last failure being: ${policyRes[0]}`));
		}
	};
	return (...args) => fromAsync(retrier(args));
}
/*        */
/*                            */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tap = (handler) => ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => (handler(e[1]), e));
/**
 *
 *
 */
const tapRight = tap;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapSpread = (handler) => ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => (handler(...e[1]), e));
/**
 *
 *
 */
const tapRightSpread = tapSpread;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapAsync = (handler) => ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => fromAsync(handler(e[1]).then(() => e)));
/**
 *
 *
 */
const tapRightAsync = tapAsync;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapAsyncSpread = (handler) => ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => fromAsync(handler(...e[1]).then(() => e)));
/**
 *
 *
 */
const tapRightAsyncSpread = tapAsyncSpread;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapError = (handler) => ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => (handler(e[0]), e));
/**
 *
 *
 */
const tapLeft = tapError;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapErrorSpread = (handler) => ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => (handler(...e[0]), e));
/**
 *
 *
 */
const tapLeftSpread = tapErrorSpread;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapErrorAsync = (handler) => {
	return ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => fromAsync(handler(e[0]).then(() => e)));
};
/**
 *
 *
 */
const tapLeftAsync = tapErrorAsync;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapErrorAsyncSpread = (handler) => {
	return ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => fromAsync(handler(...e[0]).then(() => e)));
};
/**
 *
 *
 */
const tapLeftAsyncSpread = tapErrorAsyncSpread;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapAny = (handler) => ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))((e) => (handler(e[1]), e), (e) => (handler(e[0]), e));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapAnyAsync = (handler) => ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))((e) => fromAsync(handler(e[1]).then(() => e)), (e) => fromAsync(handler(e[0]).then(() => e)));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapMatch = (params) => ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))((e) => (params.onSucceed(e[1]), e), (e) => (params.onFail(e[0]), e));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tapMatchAsync = (params) => ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))((e) => fromAsync(params.onSucceed(e[1]).then(() => e)), (e) => fromAsync(params.onFail(e[0]).then(() => e)));
/*        */
/*                               */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tryMap = (mapper, mapErr) => ((onSuccess) => (effect) => effect[$next](onSuccess))(trySync((e) => mapper(e[1]), mapErr));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tryMapSpread = (mapper, mapErr) => ((onSuccess) => (effect) => effect[$next](onSuccess))(trySync((e) => mapper(...e[1]), mapErr));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tryMapAsync = (mapper, mapErr) => ((onSuccess) => (effect) => effect[$next](onSuccess))(tryPromise((e) => mapper(e[1]), mapErr));
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const tryMapAsyncSpread = (mapper, mapErr) => ((onSuccess) => (effect) => effect[$next](onSuccess))(tryPromise((e) => mapper(...e[1]), mapErr));
/*        */
/*                              */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function unbox(unboxer = (_) => _) {
	return ((effect) => effect[$exec] === "async" ? effect.then((e) => unboxer(e[0] ?? e[1])) : unboxer(effect[0] ?? effect[1]));
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function unboxThrow(unboxer = (_) => _) {
	const valueOrThrow = (effect) => {
		if (effect[0]) throw effect[0];
		return unboxer(effect[1]);
	};
	return ((effect) => effect[$exec] === "async" ? effect.then(valueOrThrow) : valueOrThrow(effect));
}
/*        */
export { AggregatedError, UnknownError, allAsync, allSync, catchError, catchErrorAsync, catchFailure, catchFailureAsync, catchName, catchNameAsync, catchSome, catchType, catchTypeAsync, fail, failAsync, failAsyncWith, flatMap, flatMapConcat, flatMapConcatSpread, flatMapEach, flatMapEachLimit, flatMapSpread, fromBoolean, fromCoerced, fromCondition, fromExpression, fromNullable, ifImmediate, invert, isFailure, isLeft, isNone, isRight, isSome, isSuccess, left, map, mapAsync, mapAsyncSpread, mapConcat, mapConcatAsync, mapConcatAsyncSpread, mapConcatSpread, mapEach, mapEachAsync, mapEachLimit, mapError, mapErrorAsync, mapErrorDefault, mapErrorEffectDefault, mapErrorEffectPassThrough, mapErrorPassThrough, mapIf, mapIfEffect, mapLeft, mapLeftAsync, mapRight, mapRightAsync, mapRightAsyncSpread, mapRightSpread, mapSpread, match, matchAsync, matchEffect, none, pipe, pipeMap, policy, promise, promiseEffect, promiseEffectImmediate, promiseImmediate, retry, returnsEffect, right, some, succeed, succeedAsync, succeedAsyncWith, sync, syncEffect, syncEffectImmediate, syncImmediate, tap, tapAny, tapAnyAsync, tapAsync, tapAsyncSpread, tapError, tapErrorAsync, tapErrorAsyncSpread, tapErrorSpread, tapLeft, tapLeftAsync, tapLeftAsyncSpread, tapLeftSpread, tapMatch, tapMatchAsync, tapRight, tapRightAsync, tapRightAsyncSpread, tapRightSpread, tapSpread, tryMap, tryMapAsync, tryMapAsyncSpread, tryMapSpread, tryPromise, tryPromiseImmediate, tryRunPromise, tryRunSync, trySync, trySyncImmediate, unbox, unboxThrow, unless, when, whenEffect };

/*                              */